module.exports = __webpack_public_path__ + "img/infraestructura.af99e79c.png";